import PropTypes from 'prop-types';

const TooltipRedirectLink = ({ url, className }) => (
    <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={(e) => e.stopPropagation()}
    >
        Learn More
    </a>
);

TooltipRedirectLink.propTypes = {
    url: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default TooltipRedirectLink;
